export default __webpack_public_path__ + "static/media/template_pro__0008_19---MartinKabrel.02755802.png";